import React from 'react';
import {
  MenuItem,
  Select,
  Typography,
  Box,
  FormHelperText
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { generateGuid } from 'helpers';
import { Controller } from 'react-hook-form';
import { TooltipCustom } from 'components/common';

export default function FormInputSelect(props) {
  const {
    name='combo-box',
    control,
    label,
    variant='outlined',
    size='small',
    disabled=false,
    options=[],
    placeholder='',
    position='vertical',
    sx,
    helperText,
    className,
    onChange,
    display
  } = props;
  const [t, i18n] = useTranslation();
  const defaultId = !props?.id && `select-${generateGuid()}`;

  const onChangeCustom = onChange;

  const translateLabel = (option) => {
    let labelTranslated = option.label;

    if (i18n.exists(option.label)) {
      labelTranslated = i18n.t(option.label);
      if (labelTranslated.includes("returned an object instead of string")) labelTranslated = option.label;
    }

    return labelTranslated;
  }

  return (
    <Box
      sx={{
        display: display ? display : 'flex',
        gap: 0.5,
        flexDirection: position === 'vertical' ? 'column' : 'row',
        alignItems: position === 'vertical' ? 'flex-start' : 'center',
      }}
    >
      {(label !== '') &&
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <Typography variant="body1" id={`label-title-${defaultId}`}>
            {i18n.exists(label) ? t(label) : label}
          </Typography>
          {helperText && <TooltipCustom title={helperText} />}
        </Box>
      }
      <Controller
        control={control}
        name={name}
        id={defaultId}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            <Select
              variant={variant}
              onChange={ (event) => {
                event.preventDefault();
                onChange(event);
                if (onChangeCustom) {
                  onChangeCustom(event);
                }
              }}
              placeholder={placeholder}
              value={value}
              disabled={!!disabled}
              size={size}
              sx={sx}
              className={className}
              error={!!error}
            >
              {options.map((option, index) => (
                <MenuItem key={`${index}-${option.value}`} value={option.value} dense>
                  {translateLabel(option)}
                </MenuItem>
              ))}
            </Select>

            {!!error ? (
              <FormHelperText error>{error?.message}</FormHelperText>
            ) : null}
          </>
        )}
      />
    </Box>
  );
}
